import siteContent from '../../content/siteContent'
import './Team.css'

export default function Team() {
  const content = siteContent.team

  return (
    <div className="team-page">
      {/* Header Section */}
      <section className="team-header-section">
        <div className="container">
          <h1>{content.heading}</h1>
          <p className="team-intro">{content.intro}</p>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-grid">
            <div className="philosophy-image">
              <div className="philosophy-image">
                <img
                  src="/images/team-image.png"
                  alt="Team"
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'cover',
                    borderRadius: '1rem',
                    display: 'block'
                  }}
                />
              </div>
            </div>
            <div className="philosophy-content">
              <h2>{content.philosophy.title}</h2>
              <p>{content.philosophy.description}</p>
            </div>
          </div>
        </div>
      </section>


      {/* Team Cards Grid */}
      <section className="team-cards-section">
        <div className="container">
          <div className="team-grid">
            {content.members.map((member, idx) => (
              <div key={idx} className="team-card">
                <div className="team-card-image">
                <img 
                    src={`/images/team-member-${idx + 1}.png`}
                    alt={member.name}
                    className="team-member-image"
                  />
                </div>
                <div className="team-card-content">
                  <h3>{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



    </div>
  )
}
